import { useCallback } from 'react';
import { useMapsLibrary } from '@vis.gl/react-google-maps';
import { LatLngLiteral, SimLeg } from './types';

export function useDirections() {
  const routesLibrary = useMapsLibrary('routes');

  const getRoute = useCallback(
    async (points: LatLngLiteral[]) => {
      if (!routesLibrary || points.length < 2) {
        return null;
      }
      const service = new routesLibrary.DirectionsService();
      return service.route({
        origin: points[0],
        destination: points[points.length - 1],
        waypoints: points.slice(1, -1).map((location) => ({ location, stopover: true })),
        travelMode: google.maps.TravelMode.DRIVING,
      });
    },
    [routesLibrary]
  );

  return { directionsReady: !!routesLibrary, getRoute };
}

export function directionsToLegs(directions: google.maps.DirectionsResult): SimLeg[] {
  return (directions.routes[0]?.legs || []).map((leg) => ({
    miles: (leg.distance?.value || 0) / 1609.344,
    durationHours: (leg.duration?.value || 0) / 3600,
  }));
}
